import DevExpress from 'devextreme/bundles/dx.all';
import ValidationEngine from 'devextreme/ui/validation_engine';
import { dxNotify } from './dialogs';

export interface LoadOptions extends DevExpress.data.LoadOptions {
	isCountQuery?: boolean;
};

export type Store = DevExpress.data.Store;

export type DxTreeListColumn = DevExpress.ui.dxTreeListColumn;
export type DxTreeListColumnButton = DevExpress.ui.dxTreeListColumnButton;

export type DxFormEmptyItem = DevExpress.ui.dxFormEmptyItem;
export type DxFormSimpleItem = DevExpress.ui.dxFormSimpleItem;
export type DxFormGroupItem = DevExpress.ui.dxFormGroupItem;
export type DxFormButtonItem = DevExpress.ui.dxFormButtonItem;

export type DxFormItem = DxFormEmptyItem | DxFormSimpleItem | DxFormGroupItem | DxFormButtonItem;

export type DxButtonGroupItem = DevExpress.ui.dxButtonGroupItem;
export type DxMenuItem = DevExpress.ui.dxMenuItem;

//DevExpress.ui.RequiredRule | DevExpress.ui.NumericRule | DevExpress.ui.RangeRule | DevExpress.ui.StringLengthRule | DevExpress.ui.CustomRule | DevExpress.ui.CompareRule | DevExpress.ui.PatternRule | DevExpress.ui.EmailRule

export type dxValidationGroupResult = DevExpress.ui.dxValidationGroupResult;

export const validateGroup = async (validationGroupName: string): Promise<boolean> => {

	if (ValidationEngine.getGroupConfig(validationGroupName)) {

		let result = ValidationEngine.validateGroup(validationGroupName);

		if (result.status === 'pending') {

			result = await (result.complete as Promise<dxValidationGroupResult>);
		}

		!result.isValid && dxNotify(result.brokenRules?.flatMap(rule => rule.message).join('\n'), 'error', 7000);

		return result.isValid ?? false;
	}

	return false;
}

export const isGroupValid = (validationGroupName: string): boolean => {
	if (!ValidationEngine.getGroupConfig(validationGroupName)) return false;
	return ValidationEngine.validateGroup(validationGroupName).isValid ?? false;
}

export class TextValueModel {
	text?: string;
	value?: string | number | any | null;
}

export interface ISortInfo {
    selector: string;
    desc?: boolean;
}
export declare class DxSortInfo implements ISortInfo {
    selector: string;
    desc?: boolean;
}
